import { Button } from "@/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Zap, Loader2, Filter, Eye } from "lucide-react";

interface HeatmapControlsProps {
  documentColor: string;
  onGenerateHeatmap: () => void;
  isGenerating: boolean;
  hasHeatmaps: boolean;
  showSignificantOnly: boolean;
  onToggleFilter: (show: boolean) => void;
}

export function HeatmapControls({
  documentColor,
  onGenerateHeatmap,
  isGenerating,
  hasHeatmaps,
  showSignificantOnly,
  onToggleFilter
}: HeatmapControlsProps) {
  // Only show generate button when heatmaps don't exist yet
  if (!hasHeatmaps) {
    return (
      <div className="flex items-center justify-center p-3 border border-border rounded-lg bg-card">
        {/* Generate Button */}
        <Button
          onClick={onGenerateHeatmap}
          disabled={isGenerating}
          size="sm"
          style={{ backgroundColor: documentColor }}
          className="text-white hover:opacity-90 disabled:opacity-50"
        >
          {isGenerating ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
              Generating...
            </>
          ) : (
            <>
              <Zap className="h-4 w-4 mr-2" />
              Generate Heatmaps
            </>
          )}
        </Button>
      </div>
    );
  }

  // Show filter controls when heatmaps exist
  return (
    <div className="flex items-center justify-center p-3 border border-border rounded-lg bg-card">
      <ToggleGroup 
        type="single" 
        value={showSignificantOnly ? "filtered" : "all"}
        onValueChange={(value) => onToggleFilter(value === "filtered")}
        className="border border-border rounded-lg"
      >
        <ToggleGroupItem value="all" className="flex items-center gap-2">
          <Eye className="h-4 w-4" />
          All Pages
        </ToggleGroupItem>
        <ToggleGroupItem value="filtered" className="flex items-center gap-2">
          <Filter className="h-4 w-4" />
          &gt;0.1% Changes
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}